import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { IngresosComercianteModalComponent } from '../ingresos-comerciante/ingresos-comerciante-modal.component';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_229';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Muebles Leasing', listHelp: ['635'] }
];
const tableStructure = [
  {id: 'concepto', title: 'Concepto'}, 
  {id: 'valDeclarar', title: 'Valor a declarar'},
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
id: number;
concepto: string;
retencion: string;
pagador: string;
art: number;
valDeclarar:string;
}
@Component({
  selector: 'app-ingresos-otros-ingresos-modal',
  templateUrl: './ingresos-otros-ingresos-modal.component.html',
  styleUrls: ['./ingresos-otros-ingresos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosOtrosIngresosModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<IngresosOtrosIngresosModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,

    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

   /*  this.validateBtnRightActive();
    this.validateShowSave(); */
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.concepto="";
    this.modelForm.retencion="0";
    this.modelForm.pagador="";    
    this.modelForm.valDeclarar="0";
   /*  this.reloadSelArticulos(); */
  }
  

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_646 == undefined){

      this.model.doc.cuerpo.cc_id_646 = []; //Concepto
      this.model.doc.cuerpo.cc_id_650 = []; //******
      this.model.doc.cuerpo.cc_id_649 = []; //Retención
      this.model.doc.cuerpo.cc_id_651 = []; //Pagador
      this.model.doc.cuerpo.cc_id_647 = []; //Valor item
      this.model.doc.cuerpo.cs_id_648 = "0";  //Valor total
   
    }  
  }

/*   protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
    this.lstArticulos[0] = {valor:0,nombre:""};
    this.lstArticulos[1] = {valor:1,nombre:"Valor de compra: "+this.modelForm.retencion};
    this.lstArticulos[2] = {valor:2,nombre:"Valor declarado año anterior: "+this.modelForm.pagador};
    
    
    if(!conservarArt)this.modelForm.art=0;
  } */

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_646.length; i++){
      this.modelForm.id=i;
      this.modelForm.concepto=this.model.doc.cuerpo.cc_id_646[i].v;
      this.modelForm.retencion=this.model.doc.cuerpo.cc_id_649[i].v;
      this.modelForm.pagador=this.model.doc.cuerpo.cc_id_651[i].v;      
      this.modelForm.valDeclarar=this.model.doc.cuerpo.cc_id_647[i].v; 
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }
  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_646[this.modelForm.id].v=this.modelForm.concepto.toString();
    this.model.doc.cuerpo.cc_id_649[this.modelForm.id].v=this.modelForm.retencion.toString();
    this.model.doc.cuerpo.cc_id_651[this.modelForm.id].v=this.modelForm.pagador.toString();
    this.model.doc.cuerpo.cc_id_647[this.modelForm.id].v=this.modelForm.valDeclarar.toString();

  }
  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_646.push({it: i, v:this.modelForm.concepto});
    this.model.doc.cuerpo.cc_id_649.push({it: i, v:this.modelForm.retencion.toString()});
    this.model.doc.cuerpo.cc_id_651.push({it: i, v:this.modelForm.pagador.toString()});
    this.model.doc.cuerpo.cc_id_647.push({it: i, v:this.modelForm.valDeclarar.toString()});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_646.splice(index,1);
    this.model.doc.cuerpo.cc_id_649.splice(index,1);
    this.model.doc.cuerpo.cc_id_651.splice(index,1);    
    this.model.doc.cuerpo.cc_id_647.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_646.length;i++){
      this.model.doc.cuerpo.cc_id_646[i].it=i+1;
      this.model.doc.cuerpo.cc_id_649[i].it=i+1;
      this.model.doc.cuerpo.cc_id_651[i].it=i+1;      
      this.model.doc.cuerpo.cc_id_647[i].it=i+1;
      

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.concepto==undefined || this.modelForm.concepto==null || this.modelForm.concepto.trim()=="" ||
        this.modelForm.retencion==undefined || this.modelForm.valDeclarar=="0" || 
        this.modelForm.pagador==undefined /* || this.modelForm.pagador=="0" ||  */
        
  }

  public redondearFormData(){
    this.modelForm.retencion=this.dutilidades.redondearValorMoneda(this.modelForm.retencion.toString(),true);
    this.modelForm.valDeclarar=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);

  }

/*   public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();
    this.modelForm.valReajuste = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.pagador, "1.1240", true);
    this.modelForm.valReajuste = this.dutilidades.redondearValorMoneda(this.modelForm.valReajuste.toString(),true);

    switch(Number(this.modelForm.art)){
      case 1:
        this.modelForm.valDeclarar = this.modelForm.retencion;
        break;
      case 2:
        this.modelForm.valDeclarar = this.modelForm.pagador;
        break;
      case 3:
        this.modelForm.valDeclarar = this.modelForm.valReajuste;
        break;
    }
    this.reloadSelArticulos(conservarArt);
  } */


  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs648();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs648();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      //this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
/*   public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 152:
        this.operacionCs648();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
    //C151=C149-C153+C154+C155; 
    resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model.doc.cuerpo.cs_id_149,this.model.doc.cuerpo.cs_id_153, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_154, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_155, true); 
    resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
    this.model.doc.cuerpo.cs_id_151 = this.dutilidades.redondearValorMoneda(resultado,true);
    
  } */

  operacionCs648(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
    }
    this.model.doc.cuerpo.cs_id_648 = suma;

  }
 
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  


  protected controlStep(direction: DirectionType): void {
   
  }



  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs648();
    //this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_646 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs648();
    
    console.log(this.model.doc.cuerpo.cs_id_691)

    this.saveModel.emit(true);
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-otros-ingresos-modal/ingresos-otros-ingresos-modal.component.ts